export default "__VITE_ASSET__339ef73f__"